// TODO - source_types changes might effect lambdas/apiHandler/index.js; not hardcoded,
// but dependent on content of constants

module.exports = {
	BREAKPOINTS: {
		"xs": 0,
		"sm": 380,
		"md": 768, // Portrait Tablet (iPad)
		"lg": 1024, // Landscape Tablet (iPad) / Laptop
		"xl": 1440, // Desktop+
	},
	COLORS: {
		POSITIVE: "#FFC107",
		UNCERTAIN: "#57BCFA",
		NEGATIVE: "#ED412D",
		TIP: "#00CDB8",
		BLACK: "#1B1B1B",
		BLACK2: "#2D2D2D",
		WHITE: "#FFFFFF",
		WHITE2: "#FAFAFA",
		WHITE3: "rgba(250, 250, 250, 0.75)",
		PRIMARY: "#0088FF"
	},
	GA: {
		TRACKER_NAME: "shareit",
		COOKIE_DOMAIN: "shareit",
		ANONYMIZE_IP: true
	},
	SOURCE_TYPES: {
		EXTENSION: 'Chrome Extension',
		EMBEDDED: 'Widget Embedded',
		LOCAL: 'local dev'
	},
	FAB_MENU: {
		SIZE: 400,
		SHIFT_RIGHT: -150,
		SHIFT_DOWN: -112,
	},
	TIMEOUTS: {
		RECAPTCHA: 110000
	}
};